export default {"src":"/_next/static/media/rocket.2d731d59.svg","height":49,"width":50,"blurWidth":0,"blurHeight":0};